import { useContext, useEffect, useState } from "react";
import editorBg from "../../assets/img/programming.png";
import codeLoader from "../../assets/img/code-_loader.gif";
import { FileEditContext } from "./FileEditContext";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import StorageService from '../../services/api/Storage/index.js';
import axios from "axios";
import { Editor } from "@monaco-editor/react";
import { extensions, imageFileExtension } from "../../settings/shared/commonMethods.js";

const supportedFileTypes = [
    "jpeg", "jpg", "png", "pdf", "pptx",
    "doc", "docx", "json", "xlsx", "xls", "csv"
];

const EditorView = (props) => {

    const [copyFlag, setCopyFlag] = useState(false);
    const [fileType, setFileType] = useState("");
    const [fileData, setFileData] = useState("");
    const [loading, setLoading] = useState(false);
    const [expand, setExpand] = useState(false);
    const [allowEdit, setAllowEdit] = useState(false);
    const [currentFile, setCurrentFile] = useState("");
    const [activeFile, setActiveFile] = useState(0);

    const { fileContextValue, setFileContextValue, toggleTheme, setExpandView } = useContext(FileEditContext);


    useEffect(() => {
        if (fileContextValue?.length > 0) {
            let file = fileContextValue[fileContextValue?.length - 1];
            setCurrentFile(file);
            setActiveFile(fileContextValue?.length - 1);
            setFileType(file?.name?.split(".").pop()); // Get file extension (e.g: py/png/...)
            setFileData("");
            downloadObj(file?.name, "", ""); // path, storageId, root
        }
    }, [fileContextValue]);

    const downloadObj = (filePath, sId, root) => {
        if (filePath) {
            setLoading(true);
            StorageService.downloadObjectUrl(filePath, sId, root)
                .then((response) => {
                    if (response && response?.hasOwnProperty("download_url")) {
                        let download_url = response?.download_url;
                        if (supportedFileTypes.includes(fileType?.toLowerCase)) {
                            setFileData(download_url);
                            setLoading(false);
                        } else {
                            getDataFromUrl(download_url);
                        }
                    }
                }).catch((error) => {
                    setLoading(false);
                    setFileData("");
                });
        }
    }

    const getDataFromUrl = (url) => {
        axios.get(url)
            .then((response) => {
                if (response?.status === 200) {
                    setFileData(response?.data?.toString());
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            }).catch((error) => {
                setLoading(false);
            })
    }

    const handleCopyPath = (path) => {
        path && navigator.clipboard.writeText(path);
        setCopyFlag(true);
        setTimeout(() => {
            setCopyFlag(false);
        }, 3000);
    }

    const toggleExpand = () => {
        setExpand(!expand);
        setExpandView(!expand);
    }

    const getFileExtension = (type) => {
        console.log("typeee", type)
        switch (true) {
            case type === "py":
                return "python";
            case type === "js":
                return "javascript";
            case type === "ts":
                return "typescript";
            case type === "json":
                return "json";
            case type === "txt":
                return "markdown";
            default:
                return "python";
        }
    }

    const handleNewChange = (newValue, e) => {
        // console.log("newValue", newValue)
    }

    const handleClose = (item) => {
        let newFileContextValue = fileContextValue?.filter((data) => data?.name !== item?.name);
        if (newFileContextValue?.length > 0) {
            setTimeout(() => {
                setFileContextValue(newFileContextValue);
                let file = newFileContextValue[newFileContextValue?.length - 1];
                setCurrentFile(file);
                setActiveFile(newFileContextValue?.length - 1);
                setFileType(file?.name?.split(".").pop());
            }, 500);
        } else {
            setFileData("");
            setFileContextValue([]);
            setFileType("");
            setActiveFile(null);
            setCurrentFile("");
        }
    }

    const selectFile = (item, index) => {
        if (currentFile?.name !== item?.name) {
            setFileType(item?.name?.split(".").pop());
            setActiveFile(index);
            setCurrentFile(item);
            setFileData("");
            downloadObj(item?.name, "", ""); // Update Data
        }
    }

    return (
        <div className="editor-view">
            {/* Header */}
            {fileContextValue?.length > 0 && <>
                <div className="header d-flex align-items-center justify-content-between">
                    <div className="fileList d-flex align-items-center">
                        {fileContextValue?.map((item, index) => (
                            <div key={index}
                                className={`file_name d-flex align-items-center ${activeFile === index ? 'active' : ''}`}
                                onClick={() => selectFile(item, index)}
                            >
                                <span className="d-flex align-items-center">
                                    <img className="pe-2" src={extensions(imageFileExtension(item?.file_name))} alt="type" />
                                    {item?.file_name}
                                </span>
                                <OverlayTrigger placement="top"
                                    overlay={<Tooltip id="tooltip">
                                        <span className="d-inline-block font10">Close</span>
                                    </Tooltip>}>
                                    <span onClick={() => handleClose(item)}>
                                        <i className="fa-solid fa-circle-xmark"></i>
                                    </span>
                                </OverlayTrigger>
                            </div>
                        ))}
                    </div>
                    <div className="edit-btn-grp">
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">
                                <span className="d-inline-block font10">Download</span>
                            </Tooltip>}>
                            <span><i className="fa-solid fa-download"></i></span>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">
                                <span className="d-inline-block font10">Copy raw file</span>
                            </Tooltip>}>
                            <span><i className="fa-solid fa-clone"></i></span>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">
                                <span className="d-inline-block font10">Edit this file</span>
                            </Tooltip>}>
                            <span
                                className={`${allowEdit ? 'edit' : ''}`}
                                onClick={() => { setAllowEdit(!allowEdit) }}>
                                <i className="fa-solid fa-pen"></i>
                            </span>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">
                                <span className="d-inline-block font10">{expand ? 'Expanded' : 'Expand'}</span>
                            </Tooltip>}>
                            <p className={`d-inline ${expand ? 'expanded' : ''}`} onClick={() => toggleExpand()}>
                                {expand ? <i className="fa-solid fa-minimize"></i> : <i className="fa-solid fa-maximize"></i>}
                            </p>
                        </OverlayTrigger>
                    </div>
                </div>
                <div className="viewPath">
                    <span>{currentFile?.name?.replaceAll("/", " > ")}</span>
                    <OverlayTrigger placement="top"
                        overlay={<Tooltip id="tooltip">
                            <span className="d-inline-block font10">{copyFlag ? 'Copied' : 'Copy Path'}</span>
                        </Tooltip>}>
                        <span onClick={() => handleCopyPath(currentFile?.name)}>
                            {copyFlag ? <i className="fa-solid fa-check txt-green"></i> : <i className="fa-regular fa-clone"></i>}
                        </span>
                    </OverlayTrigger>
                </div>
            </>}

            {/* Editor */}
            {(fileData && fileData !== "") && fileContextValue?.length > 0 && <div className="editor">
                <Editor
                    height="80vh"
                    theme={toggleTheme ? 'vs-dark' : ''}
                    // path={fileContextValue?.file_name}
                    language={getFileExtension(fileType)}
                    value={fileData}
                    onChange={handleNewChange}
                    options={{
                        readOnly: !allowEdit,
                        selectOnLineNumbers: true,
                        contextmenu: true,
                        fontSize: 13,
                        autoIndent: "full",
                        // lineHeight: 24,
                        // automaticLayout: true
                        // renderIndentGuides: false
                    }}
                />
            </div>}

            {loading && <div className="code-loader"><img src={codeLoader} alt="img" /></div>}

            {/* No Data */}
            {!loading && (!fileData || fileData === "" || fileContextValue?.length === 0) &&
                <div className="welcome-scrn">
                    <img src={editorBg} alt="img" />
                    <p>Code Editor</p>
                </div>}
        </div>
    )
}


export default EditorView;